import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';

import { LoadFunction, MainViewState, MainViewStore } from '../../helpers/types';
import { NavService } from 'src/app/core/services/nav.service';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit, OnDestroy {
  navOpen: boolean;
  navSubscription: Subscription;
  @Input() component: string;
  @Input() loadFunction: LoadFunction;
  @Input() state: Observable<MainViewState>;

  constructor(private navService: NavService, private store: Store<MainViewStore>) {}

  ngOnInit(): void {
    this.navSubscription = this.navService.navOpen.subscribe((value: boolean) => (this.navOpen = value));
  }

  getPreviousResults(): void {
    this.state.pipe(take(1)).subscribe((state) => {
      const params = {
        ...state.params,
        offset: (state.activePageNumber - 2) * state.params.limit
      };
      this.store.dispatch(this.loadFunction(params, state.activePageNumber - 1));
    });
  }

  getNextResults(): void {
    this.state.pipe(take(1)).subscribe((state) => {
      const params = {
        ...state.params,
        offset: state.activePageNumber * state.params.limit
      };
      this.store.dispatch(this.loadFunction(params, state.activePageNumber + 1));
    });
  }

  getResultsFromPage(pageNumber: number): void {
    this.state.pipe(take(1)).subscribe((state) => {
      const params = {
        ...state.params,
        offset: (pageNumber - 1) * state.params.limit
      };
      this.store.dispatch(this.loadFunction(params, pageNumber));
    });
  }

  ngOnDestroy() {
    this.navSubscription.unsubscribe();
  }
}
